import { StarRatingDisplay } from './StarRating'
import {
  reviewAuthorName, reviewAuthorInitial, reviewAuthorAvatar,
  reviewText, reviewDateLabel, reviewIsVerified, reviewHelpfulCount, reviewImages,
} from './reviewsData'

export default function ReviewCard({ review }) {
  const name = reviewAuthorName(review)
  const avatar = reviewAuthorAvatar(review)
  const images = reviewImages(review)
  const helpful = reviewHelpfulCount(review)

  return (
    <div className="flex gap-4">
      <div className="w-11 h-11 rounded-full bg-secondary/15 text-secondary flex items-center justify-center font-bold shrink-0 overflow-hidden">
        {avatar ? (
          <img src={avatar} alt={name} className="w-full h-full object-cover" onError={(e) => { e.currentTarget.style.display = 'none' }} />
        ) : (
          reviewAuthorInitial(review)
        )}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <p className="text-sm font-semibold text-[#1C140A] flex items-center gap-1.5">
            {name}
            {reviewIsVerified(review) && (
              <span className="inline-flex items-center gap-1 text-[9px] font-bold uppercase tracking-wide px-1.5 py-0.5 rounded-full bg-green-50 text-green-600">
                ✓ Verified booking
              </span>
            )}
          </p>
          <span className="text-[11px] text-[#8B7355]">{reviewDateLabel(review)}</span>
        </div>
        <div className="mt-0.5"><StarRatingDisplay value={review.rating} size="sm" /></div>
        {review.title && <p className="mt-2 text-sm font-semibold text-[#1C140A]">{review.title}</p>}
        <p className="mt-1 text-sm leading-relaxed text-[#5C3A18] whitespace-pre-line">{reviewText(review)}</p>
        {images.length > 0 && (
          <div className="flex gap-2 mt-3 flex-wrap">
            {images.map((src) => (
              <img key={src} src={src} alt="Review attachment" className="w-16 h-16 rounded-lg object-cover border border-[#D7C29A]/30" />
            ))}
          </div>
        )}
        {helpful > 0 && (
          <p className="mt-2 text-[11px] text-[#8B7355]">👍 {helpful} found this helpful</p>
        )}
      </div>
    </div>
  )
}
